const styles = {
  container: {
    width: '100%',
    height: '100%',
  },
}

export default styles
